import FinancingType from '@carvana/merch-contracts/FinancingType';
import type { FinancingAdapterCreditStatus } from '~/contracts/common';

export default function getFinancingType(
  creditStatus: Partial<FinancingAdapterCreditStatus>
) {
  return creditStatus.hasExpiredSoftPull
    ? FinancingType.Expired
    : creditStatus.hasValidSoftPull
    ? FinancingType.UserFinancing
    : FinancingType.EstimatedFinancing;
}
